import { Fragment, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Col, Drawer, Form, Input, Row, Select, Spin } from "antd";
import PropTypes from "prop-types";

import { Modals, Types } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

import UploadImage from "components/UploadImage";
import TextEditor from "components/TextEditor";

const Component = ({
	data = {},
	onUpdate,
	options: { videos = [], sessionImages = [], files = [] },
}) => {
	const initialState = { chosenImage: "" };
	const [state, setState] = useState(initialState);
	const { loading, session, submitting, visible, chosenImage } = state;
	const { code, courseCode, title } = data;
	const { hash, pathname, search } = useLocation();
	const navigate = useNavigate();
	const [form] = Form.useForm();

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));
				hash === `#${Modals.CREATE}_${Modals.SESSION}_${Modals.TEXT}`
					? (values.type = "text")
					: hash === `#${Modals.CREATE}_${Modals.SESSION}_${Modals.IMAGE}`
					? (values.type = "image")
					: hash === `#${Modals.EDIT}_${Modals.SESSION}`
					? (values.type = session?.type)
					: (values.type = "video");

				// values.imageId = values?.image?.id;
				values.imageId = values?.image;

				// if (values.files) values.files = values.files.map(({ id }) => id);

				if (values.text) {
					values.text = values.text.replaceAll(/<\/p><p>/g, "<br />");
					values.text = values.text.replaceAll("<br>", "");
					values.text = values.text.replaceAll(
						/<\/p><p\s+class="[^"]*">/g,
						"<br />"
					);
				}
				if (values.description) {
					values.description = values.description.replaceAll(
						/<\/p><p>/g,
						"<br />"
					);
					values.description = values.description.replaceAll("<br>", "");
					values.description = values.description.replaceAll(
						/<\/p><p\s+class="[^"]*">/g,
						"<br />"
					);
				}

				delete values.image;

				const action = hash.startsWith(`#${Modals.CREATE}_${Modals.SESSION}`)
					? API.session.create(values)
					: API.session.update(code, values);

				action
					.then(() => {
						onUpdate(
							{
								code:
									hash === `#${Modals.CREATE}_${Modals.SESSION}`
										? code
										: courseCode,
							},
							hash.startsWith(`#${Modals.CREATE}_${Modals.SESSION}`)
								? false
								: true
						);
						navigate(-1);
					})
					.catch(() => {
						setState((prevState) => ({ ...prevState, submitting: false }));
					});
			});
		}
	};

	const componentDidUpdate = () => {
		if (hash.startsWith(`#${Modals.CREATE}_${Modals.SESSION}`)) {
			if (code) {
				setState((prevState) => ({ ...prevState, visible: true }));

				form.setFieldsValue({ courseId: data.id });
			} else {
				navigate({ pathname, search }, { replace: true });
			}
		} else if (hash.startsWith(`#${Modals.EDIT}_${Modals.SESSION}`)) {
			if (code) {
				setState((prevState) => ({
					...prevState,
					loading: true,
					visible: true,
				}));

				API.session.details(code).then(({ data }) =>
					setState((prevState) => ({
						...prevState,
						loading: false,
						session: data,
						chosenImage: data?.cover?.url,
					}))
				);

				form.setFieldsValue({
					...data,
					videoId: data.video?.id,
					coverId: data.cover.id,
					image: data.image?.id,
					files: data?.files?.map(({ title, id }) => (id)),

					// files: data?.files?.map(({ title, id }) => ({
					// 	label: title,
					// 	value: id,
					// })),
				});
			} else {
				navigate({ pathname, search }, { replace: true });
			}
		} else {
			if (visible) form.resetFields();

			setState(initialState);
		}
	};

	useEffect(componentDidUpdate, [hash]);

	return (
		<Drawer
			className="sp-form-drawer"
			placement={process.env.REACT_APP_IS_RTL ? "left" : "right"}
			footer={
				<>
					<Button
						type="primary"
						onClick={handleSubmit}
						loading={submitting}
					>
						{Resources.confirm}
					</Button>
					<Button
						onClick={() => navigate(-1)}
						disabled={submitting}
					>
						{Resources.cancel}
					</Button>
				</>
			}
			onClose={() => navigate(-1)}
			title={
				hash === `#${Modals.EDIT}_${Modals.SESSION}`
					? `${Resources.edit} ${Resources.session} "${title}"`
					: `${Resources.add} ${Resources.session} ${
							hash.endsWith(Modals.IMAGE)
								? `${Resources.image}${Resources.y}`
								: hash.endsWith(Modals.TEXT)
								? `${Resources.text}${Resources.y}`
								: `${Resources.video}${Resources.y}${Resources.y}`
					  } ${Resources.to} "${title}"`
			}
			maskClosable={false}
			open={visible}
			width={768}
		>
			{!loading ? (
				<Form
					layout="vertical"
					form={form}
				>
					<Form.Item
						name="title"
						label={Resources.title}
						rules={Rules.required}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="courseId"
						noStyle
					>
						<Input type="hidden" />
					</Form.Item>

					<Form.Item
						name="locked"
						label={Resources.show}
						rules={Rules.required}
					>
						<Select
							options={[
								{ value: true, label: Resources.close },
								{ value: false, label: Resources.open },
							]}
						/>
					</Form.Item>

					{hash === `#${Modals.CREATE}_${Modals.SESSION}_${Modals.VIDEO}` ? (
						<Form.Item
							name="videoId"
							label={Resources.video}
						>
							<Select
								options={videos}
								optionFilterProp="label"
								showSearch
							/>
						</Form.Item>
					) : session?.type === "video" ? (
						<Form.Item
							name="videoId"
							label={Resources.video}
						>
							<Select
								options={videos}
								optionFilterProp="label"
								showSearch
							/>
						</Form.Item>
					) : (
						""
					)}

					{hash === `#${Modals.CREATE}_${Modals.SESSION}_${Modals.TEXT}` ? (
						<Form.Item
							name="text"
							label={Resources.text}
						>
							<TextEditor />
						</Form.Item>
					) : session?.type === "text" ? (
						<Form.Item
							name="text"
							label={Resources.text}
						>
							<TextEditor />
						</Form.Item>
					) : (
						""
					)}

					{hash === `#${Modals.CREATE}_${Modals.SESSION}_${Modals.IMAGE}` ? (
						<Form.Item
							name="image"
							label={Resources.image}
						>
							{/* <UploadImage noCrop={true} section={Types.upload.session} /> */}
							<Select
								options={sessionImages}
								optionFilterProp="label"
								showSearch
							/>
						</Form.Item>
					) : session?.type === "image" ? (
						<Form.Item
							name="image"
							label={Resources.image}
						>
							{/* <UploadImage noCrop={true} section={Types.upload.session} /> */}
							<Select
								options={sessionImages}
								optionFilterProp="label"
								showSearch
							/>
						</Form.Item>
					) : (
						""
					)}

					<Form.Item
						name="description"
						label={Resources.description}
					>
						<TextEditor />
					</Form.Item>
					<Form.Item
						name="coverId"
						label={Resources.cover}
						rules={Rules.required}
					>
						<Select
							options={sessionImages}
							optionFilterProp="label"
							onChange={(e, element) => {
								setState((prev) => ({ ...prev, chosenImage: element.file }));
							}}
							showSearch
						/>
					</Form.Item>
					<Form.Item
						name="files"
						label={`${Resources.file}${Resources.ha}`}
					>
						<Select
							options={files}
							mode="multiple"
						/>
					</Form.Item>
					{chosenImage ? (
						<img
							src={chosenImage}
							className="image"
							style={{
								width: "50%",
								objectFit: "cover",
								margin: "0 auto",
								display: "block",
							}}
						/>
					) : (
						""
					)}
					<Row gutter={8}>
						<Form.List name="ingredients">
							{(fields, { add, remove }) => (
								<>
									{fields.map(({ key, name, ...restField }) => (
										<Fragment key={key}>
											<Col xs={12}>
												<Form.Item
													name={[name, "key"]}
													label={Resources.title}
													rules={Rules.required}
													{...restField}
												>
													<Input />
												</Form.Item>
											</Col>
											<Col xs={10}>
												<Form.Item
													name={[name, "value"]}
													label={Resources.value}
													rules={Rules.required}
													{...restField}
												>
													<Input />
												</Form.Item>
											</Col>
											<Col xs={2}>
												<Button
													type="link"
													onClick={() => remove(name)}
													style={{
														marginTop: 32,
														padding: 0,
													}}
													block
												>
													<i className="fa fa-minus-circle" />
												</Button>
											</Col>
										</Fragment>
									))}
									<Col xs={24}>
										<Form.Item>
											<Button
												type="dashed"
												onClick={() => add()}
												block
											>
												{`${Resources.add} ${Resources.ingredients}`}
											</Button>
										</Form.Item>
									</Col>
								</>
							)}
						</Form.List>
					</Row>
				</Form>
			) : (
				<Spin className="sp-center-spin" />
			)}
		</Drawer>
	);
};

Component.propTypes = {
	data: PropTypes.object,
	onUpdate: PropTypes.func.isRequired,
	options: PropTypes.object.isRequired,
};

export default Component;
